/* eslint-disable consistent-return */
import React from 'react';
import { Image, Text, View } from '@applane/react-core-components';
import { getUser, invoke } from '../../../AppServices';
import { Toast } from '../../../app-components';
import { Form } from '../../../app-components/form/Form';
import { multiSearchInput } from '../../../autoSuggestions';
import { dangerLogo, rescheduleIcon } from '../../../images';
import {
  getUserRole,
  validateMaxMileage,
  validateMinMileage,
} from '../../../Lib/helpers';
import vars from '../../../theme/vars';
import { ROUTES } from '../../../Lib/constants';

const computationFunction = (data) => {
  const arr = [];
  for (let i = 0; i < data?.make?.length; i += 1) {
    for (let j = 0; j < data?.model?.length; j += 1) {
      if (data?.make[i]._id === data?.model[j]?.maker?._id) {
        arr.push(data?.model[j]);
      }
    }
  }
  return {
    set: { model: arr },
  };
};

const fromYearValidation = ({ data }) => {
  if (data?.carDetails === 'Any') {
    return;
  }
  if (/^\d+\.?\d*$/.test(data?.fromYear)) {
    const currentYear = new Date().getFullYear();
    if (parseInt(data?.fromYear, 10) < 1960) {
      return 'From year must be atleast 1960';
    }
    if (parseInt(data?.fromYear, 10) > currentYear) {
      return `From year must not be greater than ${currentYear}`;
    }
  } else {
    return 'This must be a number';
  }
};

const toYearValidation = ({ data }) => {
  if (data?.carDetails === 'Any') {
    return;
  }
  if (/^\d+\.?\d*$/.test(data?.toYear)) {
    const currentYear = new Date().getFullYear();
    if (parseInt(data?.toYear, 10) > currentYear) {
      return `To year must not be greater than ${currentYear}`;
    }
    if (parseInt(data?.toYear, 10) < parseInt(data?.fromYear, 10)) {
      return 'To year must not be less than from year';
    }
  } else {
    return 'This must be a number';
  }
};

const handleSubmit = async (data, navigation, user) => {
  const toPass = {};
  const userRole = getUserRole();

  toPass.madeByName = userRole === 'superadmin' ? 'superadmin' : user.username;
  toPass.madeBy = (userRole === 'dealer' || userRole === 'superdealer') ? user.dealer : null;

  toPass.rulename = data?.rulename;
  toPass.ruleSpread = data?.ruleSpread;
  toPass.ruleEnhancement = data?.ruleEnhancement;
  toPass.minsaleperiod = data?.minsaleperiod;

  toPass.carDetails = data?.carDetails;
  toPass.mileageType = data?.mileageType;

  if (data?.carDetails === 'Enter Manually') {
    toPass.fromYear = parseInt(data?.fromYear, 10);
    toPass.toYear = parseInt(data?.toYear, 10);
    toPass.textMake = data?.textMake;
    toPass.textModel = data?.textModel;
  } else if (data?.carDetails === 'Select As Per Data') {
    toPass.fromYear = parseInt(data?.fromYear, 10);
    toPass.toYear = parseInt(data?.toYear, 10);
    toPass.make = data?.make;
    toPass.model = data?.model;

    const matchTestArr = [];
    const { make, model } = data;

    if (make && model) {
      make.forEach((makeItem) => {
        let count = 0;
        model.forEach((modelItem) => {
          if (makeItem._id === modelItem.maker._id) {
            count += 1;
          }
        });
        matchTestArr.push(count);
      });

      const someMakesHaveNoModel = matchTestArr.some((match) => match === 0);

      if (someMakesHaveNoModel) {
        Toast.show({
          message: 'Warning',
          description:
            'Some Make(s) have no model selected.\n Please select at least one.',
          type: 'warning',
          position: 'top',
          direction: 'left',
        });
      }
    }
  }

  if (data?.mileageType === 'Enter Manually') {
    toPass.minMileage = parseInt(data?.minMileage, 10);
    toPass.maxMileage = parseInt(data?.maxMileage, 10);
  }

  toPass.notifyPreference = data.notifyPreference;

  await invoke({ id: 'createRule', paramValue: { toSave: toPass } });

  Toast.show({
    message: 'Success',
    description: 'Successfully Created',
    type: 'success',
    position: 'top',
    direction: 'left',
  });
  navigation.navigate(ROUTES.avRulesListDealer.name);
};

const AddRule1 = (props) => {
  let isToVisible = false;
  let isMakeVisible = false;

  const user = getUser();

  return (
    <Form
      type="standard"
      onSubmit={({ data, navigation }) => handleSubmit(data, navigation, user)}
      validations={{
        fromYear: fromYearValidation,
        toYear: toYearValidation,
        minsaleperiod: ({ data }) => {
          if (data.minsaleperiod < 0) {
            return 'Value must be greater than or equal to zero';
          }
          return '';
        },
        minMileage: ({ data }) => validateMinMileage({
          min: data?.minMileage,
          type: data?.mileageType,
        }),
        maxMileage: ({ data }) => validateMaxMileage({
          min: data?.minMileage,
          max: data?.maxMileage,
          type: data?.mileageType,
        }),
        ruleSpread: ({ data }) => {
          if (data.ruleSpread === 0) {
            return 'Spread cant be Zero.';
          }
          if (data.ruleSpread < 5) {
            return 'Spread must be atleast 5.';
          }
          return '';
        },
      }}
      computations={{
        self: {
          model: {
            compute: computationFunction,
            onChange: ['make'],
          },
        },
      }}
      mandatory={{
        rulename: 1,
        minsaleperiod: 1,
        ruleSpread: 1,
        ruleEnhancement: 1,
        mileageType: 1,
        carDetails: 1,
        minMileage: ({ data }) => (data && data.mileageType && data.mileageType === 'Enter Manually'
          ? 1
          : 0),
        maxMileage: ({ data }) => (data && data.mileageType && data.mileageType === 'Enter Manually'
          ? 1
          : 0),

        fromYear: ({ data }) => (data?.carDetails === 'Select As Per Data'
          || data?.carDetails === 'Enter manually'
          ? 1
          : 0),
        toYear: ({ data }) => (data?.carDetails === 'Select As Per Data'
          || data?.carDetails === 'Enter manually'
          ? 1
          : 0),

        make: ({ data }) => (data && data.carDetails && data.carDetails === 'Select As Per Data'
          ? 1
          : 0),
        model: ({ data }) => (data && data.carDetails && data.carDetails === 'Select As Per Data'
          ? 1
          : 0),

        textMake: ({ data }) => (data && data.yearRadio && data.carDetails === 'Enter Manually'
          ? 1
          : 0),
        textModel: ({ data }) => (data && data.yearRadio && data.carDetails === 'Enter Manually'
          ? 1
          : 0),
      }}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          // general stuff
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label: 'Rule Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid ${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    field: 'rulename',
                    label: 'Rule Name',
                    description:
                      'Name of the rule you want to give , this will be shown in the rules list',
                    mandatory: true,
                    allowWhiteSpaces: true,
                  },
                  {
                    type: 'number',
                    field: 'minsaleperiod',
                    label: 'Min Sale Period (Months)',
                    description:
                      'This is to remove recent sales from being appraised. Ex. 6 (months prior to service date)',
                    mandatory: true,
                  },
                  {
                    type: 'number',
                    field: 'ruleSpread',
                    label: 'Spread',
                    description:
                      'Creates the percentage range for the final appraisal.',
                    mandatory: true,
                  },
                  {
                    type: 'number',
                    field: 'ruleEnhancement',
                    label: 'Enhancement',
                    description:
                      ' Enhances the appraised value to be presented, up or down, to be used in the spread.',
                    mandatory: true,
                  },
                ],
              },
            ],
          },
          // mileage type
          {
            columnsPerRow: 1,
            fieldVariant: 'filled',
            label: 'Mileage',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid ${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    type: 'radioGroup',
                    field: 'mileageType',
                    variant: 'filled',
                    label: 'Mileage',
                    container: 'topLabel',
                    options: ['All', 'Enter Manually'],
                    description:
                      'Selecting All will bypass the mileage range test | Selecting Enter manually will ask for the mileage range',
                  },
                ],
              },
            ],
          },
          // min , max mileage range
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    field: 'minMileage',
                    label: 'Min Mileage',
                    description: 'Minimum mileage value you want to set.',
                    visible: ({ data = {} }) => data?.mileageType === 'Enter Manually',
                  },
                  {
                    type: 'text',
                    field: 'maxMileage',
                    label: 'Max Mileage',
                    description: 'Maximum mileage value you want to set.',
                    visible: ({ data = {} }) => data?.mileageType === 'Enter Manually',
                  },
                ],
              },
            ],
          },
          // car details radio
          {
            columnsPerRow: 1,
            fieldVariant: 'filled',
            label: 'car Details',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid ${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    render: () => (
                      <View
                        style={{
                          disply: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        {user?.dealer?.bulkCalls === 'Pending' ? (
                          <Image
                            source={dangerLogo}
                            style={{ width: 20, height: 20 }}
                          />
                        ) : null}
                        <Text
                          style={{
                            paddingTop: 5,
                            color: 'orange',
                            marginLeft: 4,
                          }}
                        >
                          {user?.dealer?.bulkCalls === 'Pending'
                            ? 'Fetch Calls Pending'
                            : null}
                        </Text>
                      </View>
                    ),
                    visible: () => user?.dealer?.bulkCalls === 'Pending',
                  },
                  {
                    type: 'radioGroup',
                    field: 'carDetails',
                    variant: 'filled',
                    label: 'Details Type',
                    options:
                      user?.dealer?.bulkCalls === 'Complete'
                        ? ['Select As Per Data', 'Enter Manually', 'Any']
                        : ['Enter Manually', 'Any'],
                    description:
                      'Selecting "Select As Per Data" will fetch results from the Master Data uploaded along with year range fields that are manually input.<br> Selecting "Enter Manually" allows manual entry for Year, Make and Model.<br> Selecting "Any" will let the rule pull all vehicles.',
                  },
                ],
              },
            ],
          },
          // year range , manual entry
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: [
                  {
                    type: 'text',
                    field: 'fromYear',
                    label: 'From',
                    description: 'Provide a year range',
                    visible: ({ data = {} }) => (data?.carDetails === 'Select As Per Data'
                      || data?.carDetails === 'Enter Manually'
                      ? 1
                      : 0),
                  },
                  {
                    type: 'text',
                    field: 'toYear',
                    label: 'To',
                    description: 'Provide a year range',
                    visible: ({ data = {} }) => {
                      if (/^\d+\.?\d*$/.test(data?.fromYear)) {
                        const radioCondition = !!(
                          data?.carDetails === 'Select As Per Data'
                          || data?.carDetails === 'Enter Manually'
                        );

                        const currentYear = new Date().getFullYear();
                        const rangeCondition = parseInt(data?.fromYear, 10) >= 1960
                          && parseInt(data?.fromYear, 10) <= currentYear;

                        if (radioCondition && rangeCondition) {
                          isToVisible = true;
                        } else {
                          isToVisible = false;
                        }
                      } else {
                        isToVisible = false;
                      }
                      return isToVisible;
                    },
                  },
                  {
                    type: 'text',
                    field: 'textMake',
                    label: 'Enter Make',
                    description: 'Enter make of vehicle',
                    visible: ({ data }) => data?.carDetails === 'Enter Manually',
                  },
                  {
                    type: 'text',
                    field: 'textModel',
                    label: 'Enter Model',
                    description: 'Enter model of vehicle',
                    visible: ({ data }) => data?.carDetails === 'Enter Manually',
                  },
                ],
              },
            ],
          },
          // car type radio
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: [
                  multiSearchInput(
                    {
                      icon: rescheduleIcon,
                      field: 'make',
                      query: 'makersList',
                      model: 'CarMaker',
                      idField: '_id',
                      label: 'Make',
                      placeholder: 'Select',
                      searchField: 'name',
                      suggestionField: 'name',
                      valueField: 'name',
                      mandatory: true,
                      selectAll: true,
                      description: 'Select make(s) of the vehicle',
                      visible: ({ data = {} }) => {
                        const { fromYear, toYear, carDetails } = data;
                        if (
                          fromYear
                          && toYear
                          && carDetails
                          && carDetails === 'Select As Per Data'
                          && isToVisible
                        ) {
                          isMakeVisible = true;
                        } else {
                          isMakeVisible = false;
                        }
                        return isMakeVisible;
                      },
                    },
                    {
                      addOnFilter: () => ({
                        dealer: {
                          _id:
                            (user?.role?.code === 'dealer' || user?.role?.code === 'superdealer')
                              ? user?.dealer?._id
                              : props?.navigation?.state?.params?.item?.madeBy
                                ?._id,
                        },
                      }),
                    },
                  ),

                  multiSearchInput(
                    {
                      icon: rescheduleIcon,
                      field: 'model',
                      query: 'carModelList',
                      model: 'CarModel',
                      idField: '_id',
                      label: 'Model',
                      placeholder: 'Select',
                      searchField: 'name',
                      suggestionField: 'name',
                      valueField: 'name',
                      mandatory: true,
                      selectAll: true,
                      description: 'Select model(s) of vehicle',
                      visible: ({ data = {} }) => data?.make
                        && data?.make?.length !== 0
                        && data?.carDetails === 'Select As Per Data'
                        && isMakeVisible,
                    },
                    {
                      addOnFilter: ({ data = {} }) => {
                        const stores = data?.make?.map((store) => store._id);
                        return { maker: { _id: { $in: stores } } };
                      },
                    },
                  ),
                ],
              },
            ],
          },
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            label:
              'You will be notified for every appraisal under this custom rule by the method of your choice',
            labelStyle: {
              ...vars.headings.h8,
              color: vars.colors.grey.color2,
              textTransform: 'uppercase',
            },
            groupsContainerStyle: {
              borderTop: `1px solid ${vars.colors.grey.color2}`,
            },
            groups: [
              {
                columns: [
                  {
                    type: 'checkBoxGroup',
                    field: 'notifyPreference',
                    label: 'Notification Preference',
                    options: ['Email', 'Text'],
                    optionStyle: {
                      ...vars.headings.h10,
                      color: '#333',
                      marginLeft: 8,
                      marginRight: 12,
                    },
                    visible: ({ data }) => {
                      if (data.carDetails && data.carDetails !== 'Any') {
                        return true;
                      }
                      return false;
                    },
                  },
                ],
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};
export default AddRule1;
